import { useEffect, useRef } from "react";

// HOOKS
import useScreenSize from "../../../../hooks/useScreenSize";

// REDUX
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";

// CONNECTORS
import { generateAccess } from "../../../../connectors/cryptoApi";

// UTILS
import { openExternal } from "../../../NavBar/utils/utils";

// COMPONENTS
import { ModalBody, ModalHeader } from "@nextui-org/react";
import Spinner from "../../../Spinner/Spinner";

// CONSTANTS
import { MOBILE_OPERATE_WIDTH } from "../../../OperateMEP/constants";

// STYLES
import styles from "./RedirectModal.module.scss";
import { updateCryptoStep } from "../../../../store/slices/cryptoSlice";


interface Props {
  onClose: () => void;
  companyName: string;
  isCryptoOnly: boolean;
}
const RedirectModal = ({
  companyName,
  onClose,
  isCryptoOnly,
}: Props) => {
  const dispatch = useAppDispatch();
  const { header, description, spinnerContainer, content } = styles;
  const { isMobile } = useScreenSize(MOBILE_OPERATE_WIDTH);
  const { selectedAccount } = useAppSelector((state) => state.crypto);
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (hasRedirected.current || !selectedAccount) return;

    const handleAccess = async () => {
      hasRedirected.current = true;
      try {
        const { url } = await generateAccess(Number(selectedAccount));
        openExternal(url, "_blank");
      } catch (e) {
        console.error(e);
      } finally {
        if (isCryptoOnly) {
          dispatch(updateCryptoStep("ACCOUNTS"));
        } else {
          onClose();
        }
      }
    };
    handleAccess();
  }, [
    selectedAccount,
    isCryptoOnly,
    dispatch,
    onClose,
  ]);

  return (
    <>
      <ModalHeader className={`justify-center ${isMobile && "pt-[40%] pb-0"}`}>
        <div className={spinnerContainer}>
          <Spinner />
        </div>
      </ModalHeader>
      <ModalBody className={`${content} ${isMobile && "pt-0"}`}>
        <span className={header}>Cargando...</span>
        <span className={description}>
          Te estamos redirigiendo a {companyName}
        </span>
      </ModalBody>
    </>
  );
};

export default RedirectModal;
